import { AnnotationType, ActivitiesType } from '@tabeeb/contracts/main-api/swagger-main-api'

export function getAnnotationMessage(annotation) {
  switch (annotation.type) {
    case AnnotationType.HotSpot:
      return 'placed a flag.'
    case AnnotationType.LinkedPage:
      return 'took a photo.'
    case AnnotationType.Text:
      return annotation.parentId ? 'commented on a flag.' : 'added a text annotation.'
    case AnnotationType.Audio:
      return annotation.parentId ? 'left a voice message on a flag.' : 'recorded a voice over.'
    case AnnotationType.StrokeDrawShapeLine:
    case AnnotationType.StrokeDrawShapeRectangle:
    case AnnotationType.StrokeDrawShapeEllipse:
    case AnnotationType.StrokeDrawShapeRectangleFilled:
    case AnnotationType.StrokeDrawShapeEllipseFilled:
    case AnnotationType.StrokeDrawShapeLineArrowEnd:
    case AnnotationType.StrokeDrawShapeLineArrowBoth:
      return 'added a shape.'
    case AnnotationType.AI:
      return 'commented on an AI flag.'
    default:
      return 'drew something.'
  }
}

export const displayActivityTypes = {
  [ActivitiesType.Flag]: [AnnotationType.HotSpot, AnnotationType.Text, AnnotationType.Audio],
  [ActivitiesType.Drawing]: [AnnotationType.StrokeDraw, AnnotationType.StrokeErase, AnnotationType.Laser],
  [ActivitiesType.Image]: [AnnotationType.LinkedPage],
  [ActivitiesType.Shape]: [
    AnnotationType.StrokeDrawShapeLine,
    AnnotationType.StrokeDrawShapeRectangle,
    AnnotationType.StrokeDrawShapeEllipse,
    AnnotationType.StrokeDrawShapeRectangleFilled,
    AnnotationType.StrokeDrawShapeEllipseFilled,
    AnnotationType.StrokeDrawShapeLineArrowEnd,
    AnnotationType.StrokeDrawShapeLineArrowBoth,
  ],
  [ActivitiesType.Text]: [AnnotationType.Text],
  [ActivitiesType.Audio]: [AnnotationType.Audio],
  [ActivitiesType.AIFlag]: [AnnotationType.AI],
}

export function timeFormatSeconds(seconds) {
  if (seconds === null || seconds <= 0) return null

  const date = new Date(1970, 0, 1)
  date.setSeconds(seconds)
  return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1')
}

export function getIsTextSearchDisabled(activitiesType) {
  return [ActivitiesType.Image, ActivitiesType.Shape, ActivitiesType.Audio, ActivitiesType.Drawing].includes(
    activitiesType
  )
}
